import { SHOW_TASK_DETAILS, HIDE_TASK_DETAILS, UPDATE_TASK_DETAILS } from './actionTypes';

export const showTaskDetailsAction = ({ taskIds = [], onDelete, employee }) => ({
  type: SHOW_TASK_DETAILS,
  data: {
    taskIds,
    onDelete,
    // employee
  },
});

export const updateTaskDetailsAction = ({ taskIds = [], onDelete, onUpdate, employee }) => ({
  type: UPDATE_TASK_DETAILS,
  data: {
    onDelete,
    employee,
    onUpdate,
  },
});

export const hideTaskDetailsAction = () => ({
  type: HIDE_TASK_DETAILS,
});
